import { useSearchParams } from 'react-router-dom';
import { createConditionalLogger } from '../../../../utils/logger';
import { useFeatureFlags } from '../../../../contexts/FeatureFlagsContext';
import { FeatureFlags } from '../../../../flags';

/**
 * React hook that returns a conditional logger based on the MEDIA_DEBUG feature flag
 * or ?debug URL parameter.
 * Used by the Media Center V2 components in src/pages/edit/media
 */
export const useMediaLogger = (componentName: string = 'MediaV2') => {
  const { hasFeature } = useFeatureFlags();
  const [searchParams] = useSearchParams();

  const isDebugEnabled =
    hasFeature(FeatureFlags.NGW_MEDIA_DEBUG) || searchParams.has('debug');

  return createConditionalLogger(isDebugEnabled, componentName);
};
